module.exports = __webpack_public_path__ + "static/img/cert-auth-1.b747b0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cert-auth-1.png
// module id = 2ozV
// module chunks = 0